<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
                <!-- 左侧竖向步骤条 -->
                <div style="width: 240px; min-width: 240px; margin-right: 24px;">
                    <el-steps direction="vertical" :active="activeValue">
                      <el-step v-for="(item, index) of activeList" :key="index" :title="item.processNodeName" :status="item.stepStatus || 'process'">
                        <template slot="description">
                          <div v-if="item.processNodeName === '制单人'">
                            {{ item.approvalTime }}
                          </div>
                          <div v-else>
                            <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                            <div>流程节点：{{ item.processNodeName || '' }}</div>
                            <div>经办人：{{ item.maker || '' }}</div>
                            <div v-if="item.stepStatus !== 'process'">备注：{{ item.remark || (item.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                            <div>时间：{{ item.makerTime || '' }}</div>
                          </div>
                        </template>
                      </el-step>
                    </el-steps>
                </div>
                <!-- 右侧内容 -->
                <div style="flex: 1; overflow-x: auto;">
                    <Boyo-Formtwo :formInfo="formInfo2"
                            :refObj.sync="formInfo2.ref"
                            :listTypeInfo='listTypeInfo'
                            @handlePictureCardPreview="handlePictureCardPreview">
                    </Boyo-Formtwo>
                    <el-table :data="tableData"
                            border
                            max-height="430"
                            style="width: 99%;"
                            :header-cell-style="{background:'rgb(189,215,252)',color:'#3C3C3C',padding:'4px 0'}"
                            :cell-style="{padding:'2px'}">
                        <el-table-column
                            prop="accessPerson"
                            label="评铁员"
                            width="110">
                        </el-table-column>
                        <el-table-column
                            prop="price"
                            label="单价"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            prop="deductTotal"
                            label="总扣杂/Kg"
                            width="110">
                        </el-table-column>
                        <el-table-column
                            prop="deductIron"
                            label="生铁类扣杂"
                            width="90">
                        </el-table-column>
                        <el-table-column
                            prop="deductSeal"
                            label="镀锌类/油漆类/密封件类/钢丝类"
                            width="130">
                        </el-table-column>
                        <el-table-column
                            prop="deductSoil"
                            label="土/塑料/铁锈/其他杂质"
                            width="110">
                        </el-table-column>
                        <el-table-column
                            prop="deductWater"
                            label="水/油扣杂"
                            width="90">
                        </el-table-column>
                        <el-table-column
                            prop="impurities"
                            label="其他扣杂"
                            width="90">
                        </el-table-column>
                        <el-table-column
                            prop="priceAdjust"
                            label="单价调整(每吨扣多少)"
                            width="110">
                        </el-table-column>
                        <el-table-column
                            prop="grade"
                            label="料型">
                        </el-table-column>
                        <el-table-column
                            prop="loadPlaceName"
                            label="卸货仓库">
                        </el-table-column>
                        <el-table-column
                            prop="gradeActual"
                            label="实际物料"
                            v-if="showGradeActualColumn">
                        </el-table-column>
                        <el-table-column
                            prop="submitStatus" width="70"
                            label="是否提交">
                            <template slot-scope="scope">
                            <el-select v-model="scope.row.submitStatus" disabled v-if="scope.row.accessPerson != '最终值' && scope.row.accessPerson != '平均值'">
                                <el-option v-for="item in listTypeInfo.submitStatus"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-if="scope.row.accessPerson == '最终值' || scope.row.accessPerson == '平均值'"></span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center"
                                        label="图片" fixed="right"
                                        width="70px">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="viewImg(scope.row)" v-if="scope.row.accessImage || scope.row.accessImage2 || scope.row.accessImage3 || scope.row.accessImage4 || scope.row.accessImage5 || scope.row.accessImage6 || scope.row.accessImage7 || scope.row.accessImage8 || scope.row.accessImage9 || scope.row.accessImage10"
                                    type="primary"
                                    size="mini">
                            查看
                            </el-button>
                        </template>
                        </el-table-column>
                        <el-table-column align="center"
                                        label="视频" fixed="right"
                                        width="70px">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="viewVideo(scope.row)" v-if="scope.row.accessVideo1 || scope.row.accessVideo2 || scope.row.accessVideo3"
                                    type="success"
                                    size="mini">
                            查看
                            </el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                    
                    <!-- 审核表单 --> 
      <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
        <!-- 添加快捷短语区域 -->
        <div class="quick-phrase-area">
          <div class="quick-phrase-label">常用快捷短语:</div>
          <div class="quick-phrase-buttons">
            <el-button 
                v-for="(phrase, index) in quickPhrases" 
                :key="index"
                size="mini"
                @click="insertQuickPhrase(phrase)"
                class="phrase-btn">
                {{ phrase }}
            </el-button>
          </div>
        </div>
                        <Boyo-Formtwo :formInfo="formInfoAuditData"
                                :refObj.sync="formInfoAuditData.ref"
                                :listTypeInfo="listTypeInfo">
                        </Boyo-Formtwo>
                    </div>
                </div>
            </div>
            </Boyo-Dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="pingImgUrl+dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible2" class="imgDialog">
            <img width="100%" :src="dialogImageUrl2" alt="">
        </el-dialog>
        <el-dialog :visible.sync="thumbnailDialogVisible" title="图片列表" width="80%">
          <div class="dialog-header">
            <i class="el-icon-close close-icon" @click="thumbnailDialogVisible = false"></i>
          </div>
          <div class="thumbnail-container">
            <div v-for="(img, index) in imgViewerList" :key="index" class="thumbnail-item" @click="previewImage(index)">
              <img :src="img" :alt="'图片'+(index+1)" class="thumbnail-img">
            </div>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="videoDialogVisible" title="视频预览" width="70%" :append-to-body="true" :close-on-click-modal="true" :before-close="handleVideoDialogBeforeClose">
          <div v-if="videoList.length > 0">
            <video :src="videoList[videoIndex]" controls class="video-player" style="width:100%;max-height:70vh;background:#000" playsinline webkit-playsinline></video>
            <div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px;">
              <div>
                <el-button size="mini" @click="prevVideo" :disabled="videoIndex === 0">上一条</el-button>
                <el-button size="mini" @click="nextVideo" :disabled="videoIndex >= videoList.length - 1">下一条</el-button>
              </div>
              <div>
                <el-button size="mini" type="primary" @click="openCurrentVideo">在新标签打开</el-button>
              </div>
            </div>
            <div style="margin-top:10px;max-height:160px;overflow:auto;border-top:1px solid #eee;padding-top:8px;">
              <el-tag v-for="(url, idx) in videoList" :key="idx" :type="idx===videoIndex?'primary':'info'" style="margin:4px;cursor:pointer" @click="selectVideo(idx)">
                第{{ idx + 1 }}段
              </el-tag>
            </div>
          </div>
        </el-dialog>
      <image-viewer v-if="imgViewerVisible" :urlList="imgViewerList" :initialIndex="currentImageIndex" :on-close="onClose" :imgStyle="'width:50%;height:auto;z-index: 99;'" :z-index="3000" />
    </div>
</template>

<script>
import BoyoFilter from '@/components/BoyoFilter'
import BoyoContent from '@/components/BoyoContent'
import BoyoButton from '@/components/BoyoButton'
import BoyoTable from '@/components/BoyoTable'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'
import ImageViewer from "element-ui/packages/image/src/image-viewer"
export default {
  name: 'AccessListDialog',
  components: {
    BoyoFilter,
    BoyoContent,
    BoyoButton,
    BoyoTable,
    BoyoDialog,
    BoyoForm,BoyoFormtwo,
    ImageViewer
  },
  props: {},
  data () {
    return {
      activeValue:null,
      activeList:[],
      dataId:'',
      search: {},
      tableData:[],
      detailDate:{},
      billId:'',
      maker:'无',
      makerTime:'',
      add2:0,
      dialogVisible:false,
      dialogImageUrl:'',
      dialogImageUrl2: '',
      dialogVisible2: false,
      pingImgUrl: config.pingImgUrl,
      amountUnit:localStorage.amountUnit,
      auditParm:{},
      thumbnailDialogVisible: false,
      videoDialogVisible: false,
      videoIndex: 0,
      imgViewerVisible:false,
      imgViewerList:[],
      videoList:[],
      quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '评铁单'
        ],
        showPhraseManager: false,
        newPhrase: '',
      currentImageIndex: 0,
      showAuditDataFields: false,
      // 下拉框相关信息
      listTypeInfo: {
        purMode :[],
        submitStatus:[{ label: '否', value: 0 },{ label: '是', value: 1 }],
        statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
        processId:[],
      },
      formInfo2: {
        ref: null,
        labelWidth: "112px",
        inline: true,
        data: {
          id: null,
          accessNo:'',
          accessDate:'',
          carNo:'',
          containerNumber:'',
          purMode:'',
        },
        list: [
          {type: "text",label: "单号：",value: "accessNo", style: 'width:95%', className: 'form_item_two',disabled:true},
            {type: "text",label: "日期：",value: "accessDate", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "车牌号：",value: "carNo", style: 'width:95%', className: 'form_item_two',disabled:true},
          {type: "text",label: "货柜号：",value: "containerNumber", style: 'width:95%', className: 'form_item_two',disabled:true},
        ],
        rules: {}
      },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '评铁对应数据', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false ,show:false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
        formInfoAuditData: {
          ref: null,
          labelWidth: '100px',
          data: {
            id:'',
            processId:'',
            remark:'',
            status:'',
          },
          list: [
            { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
            { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
            { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
          ],
          rules: {
            status:[{ required: true, trigger: 'change',message: '请选择' }]
          }
        },
    }
  },
   computed: {
    // 计算属性：判断是否显示实际物料列
    showGradeActualColumn() {
      // 如果purMode为0或4，则不显示实际物料列
      return this.formInfo2.data.purMode !== 0 && this.formInfo2.data.purMode !== 4;
    }
  },
  created () {
  },
  mounted () {
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,enumCategoryCode:'PurMode'}).then(res => {
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.purMode.push({value: Number(list1[i].enumName), label: list1[i].enumValue})
            }
        }
    })
    // 获取流程枚举
    this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
      if(res.code == 0) {
        let list1 = res.data.list
        for( let i in list1 ) {
          this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
        }
      }
    })
  },
  methods: {
    dialogShow(data,val,parm,id,maker,makerTime){
        this.billId = data
        this.dataId = id
        this.maker = maker || '无'
        this.makerTime = makerTime || ''
        if(parm && parm.id){
          this.auditParm = parm
          this.dialogInfoData.btList[0].show = true
          this.showAuditDataFields = true
          
          // 初始化审核表单数据
          this.$nextTick(() => {
            for (const key in this.formInfoAuditData.data) {
              this.formInfoAuditData.data[key] = ''
            }
            
            // 查找并设置流程名称
            const loadProcessEnum = () => {
              return new Promise((resolve) => {
                if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                  resolve();
                } else {
                  this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                    if(res.code == 0) {
                      let list1 = res.data.list
                      for(let i in list1) {
                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                      }
                      resolve();
                    } else {
                      this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                      resolve();
                    }
                  }).catch(() => {
                    resolve();
                  });
                }
              });
            };
            
            // 加载流程枚举后再设置流程名称
            loadProcessEnum().then(() => {
              let processFound = false;
              for (let inde of this.listTypeInfo.processId) {
                if (parm.processId == inde.enumValue) {
                  this.formInfoAuditData.data.processId = inde.value
                  processFound = true;
                  break;
                }
              }
              
              // 如果没找到匹配的流程，记录日志并设置一个默认值
              if (!processFound) {
                console.warn('未找到匹配的流程ID:', parm.processId, '可用的流程枚举:', this.listTypeInfo.processId);
                // 直接使用processId作为备选
                this.formInfoAuditData.data.processId = parm.processId;
              }
              
              this.formInfoAuditData.data.status = 1
            });
          })
        }else{
          this.dialogInfoData.btList[0].show = false
          this.showAuditDataFields = false
        }
        this.getInfo(val)
    },
    formatAmount(cellValue) {
      if (typeof cellValue == 'number') {
        cellValue = Number(cellValue.toFixed(2))
        return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
          return cellValue
      }
    },
    // 搜索事件
    getInfo (val) {
      this.$api.system.getActProcessEntryPage({idProcessInstance:this.dataId,pageNum:1,pageSize:999}).then(res => {
          if (res.code == 0) {
              this.activeList = []
              this.activeValue = 0
              for (let i in res.data.list) {
                  if(res.data.list[i].status && i < res.data.list.length){
                      this.activeValue = Number(Number(i) + 1)
                  }
                  let stepStatus = 'process';
                  if (res.data.list[i].status == 1) {
                    stepStatus = 'success';
                  } else if (res.data.list[i].status == 2) {
                    stepStatus = 'error';
                  } else {
                    stepStatus = 'process';
                  }
                  this.activeList.push({
                    processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
                    maker: res.data.list[i].status
                      ? res.data.list[i].actualApprover
                      : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
                    remark: res.data.list[i].remark || '', // 第三行：备注
                    makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
                    stepStatus
                  });
              }
              
              // 始终在最前面插入"制单人"节点
              let approvalTime = this.maker + (this.makerTime ? (' ' + this.makerTime) : '');
              this.activeList.unshift({ processNodeName: '制单人', approvalTime });
              this.activeValue = (this.activeValue || 0) + 1;
          }else{
              this.$message({ message: res.msg, type: "error" });
          }
      })
      this.$api.access.getPurAccessPage({id:this.billId,pageNum:1,pageSize:0}).then(
        res => {
          if (res.code == 0) {
            if(res.data.list.length > 0){
                this.detailDate = res.data.list[0]
                for (let key in this.formInfo2.data) {
                  this.formInfo2.data[key] = ''
                }
                this.detailDate.accessDate = this.detailDate.accessDate?this.detailDate.accessDate.substring(0,10):''
                for (let key in this.detailDate) {
                  if (key in this.formInfo2.data) {
                    this.formInfo2.data[key] = this.detailDate[key];
                  }
                }
                this.$api.access.getPurAccessAndDetailList({idAccess:this.detailDate.id,pageNum:1,pageSize:999}).then(res => {
                  if (res.code == 0) {
                    this.tableData = res.data.list
                    if(res.data.list.length > 0){
                      this.tableData.push({accessPerson:'最终值',price:this.detailDate.evaluationPrice?this.detailDate.evaluationPrice:'',deductTotal:this.detailDate.deductFinal?this.detailDate.deductFinal:'',priceAdjust:this.detailDate.priceAdjust?this.detailDate.priceAdjust:'',grade:this.detailDate.grade?this.detailDate.grade:this.tableData[0].grade,loadPlaceName:this.detailDate.loadPlaceName?this.detailDate.loadPlaceName:this.tableData[0].loadPlaceName})
                    }
                  }else{
                    this.$message({ message: res.msg, type: "error" });
                  }
                })
                if(!val){
                  this.dialogInfoData.visible = true
                }
            } else {
                this.$message({ message: '对应数据查找为空', type: 'warning' })
            }
          }else{
            this.$message({ message: res.msg, type: "error" });
          }
        },
        err => {
          console.log(err)
          this.content.loading = false
        }
      )
    },
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'save':
              this.formInfoAuditData.ref.validate(valid => {
                if (valid) {
                  let parma = {
                    id: this.auditParm.id,
                    processId: this.formInfoAuditData.data.processId,
                    status: this.formInfoAuditData.data.status,
                    remark: this.formInfoAuditData.data.remark
                  }
                  dialogInfoData.btList[0].loading = true
                  this.$api.system.approval(parma).then(res => {
                      dialogInfoData.btList[0].loading = false
                      if (res.code === 0) {
                          this.$message({ message: res.msg, type: 'success' })
                          dialogInfoData.visible = false
                          this.$emit('approvalInfo')
                      } else {
                          this.$message({ message: res.msg, type: 'error' })
                      }
                  }).catch(() => {
                    dialogInfoData.btList[0].loading = false
                  })
                }
              })
              break
            case 'close':
                dialogInfoData.visible = false
                break
        }
    },
    // 表单内部事件
    formClick (event) {
      switch (event) {
      }
    },
    previewAvatar(file) { // 查看文件
      window.open(config.pingImgUrl + file.url)
    },
    handlePictureCardPreview (url, value) {
      if(url){
        this.dialogVisible2 = true
        this.dialogImageUrl2 = url
      }
    },
    viewImg(row){
      this.imgViewerList = []
      for (let j = 1; j < 15; j++) {
        if (j == 1 && row.accessImage) {
          this.imgViewerList.push(this.pingImgUrl + row.accessImage)
        }else if (row['accessImage'+j]) {
          this.imgViewerList.push(this.pingImgUrl + row['accessImage'+j])
        }
      }
      // 特殊处理第15个字段，可能包含多个图片路径，用逗号分隔
      if (row.accessImage15) {
        const images = row.accessImage15.split(',')
        images.forEach(img => {
          if (img && img.trim()) {
            this.imgViewerList.push(this.pingImgUrl + img.trim())
          }
        })
      }
  
  // 3. 新增：处理 accessImageSupplement（补充图片）
  if (row.accessImageSupplement) {
    row.accessImageSupplement.split(',')
      .filter(img => img.trim()) // 过滤空值
      .forEach(img => {
        this.imgViewerList.push(this.pingImgUrl + img.trim())
      })
  }
  
  // 4. 显示缩略图弹窗
  this.$nextTick(() => {
    this.thumbnailDialogVisible = true
  })
  
  // 调试输出
  // console.log('图片列表:', this.imgViewerList)
},
    viewVideo(row){
      this.videoList = []
      this.videoIndex = 0
      // 兼容 accessVideo1 含多个地址（逗号分隔）及 accessVideo2/3
      const acc = []
      for (let j = 1; j <= 3; j++) {
        const v = row['accessVideo'+j]
        if (v) acc.push(String(v))
      }
      const flat = []
      acc.forEach(s => {
        s.split(',').forEach(u => {
          const t = (u || '').trim()
          if (t) flat.push(t)
        })
      })
      this.videoList = flat.map(u => (/^(https?:)?\/\//i.test(u) ? u : (this.pingImgUrl + u)))
      this.$nextTick(()=>{
        this.videoDialogVisible = this.videoList.length > 0
        if (!this.videoDialogVisible) {
          this.$message.warning('暂无视频')
        }
      })
    },
    selectVideo(idx){
      if (idx >= 0 && idx < this.videoList.length) this.videoIndex = idx
    },
    nextVideo(){
      if (this.videoIndex < this.videoList.length - 1) this.videoIndex += 1
    },
    prevVideo(){
      if (this.videoIndex > 0) this.videoIndex -= 1
    },
    openCurrentVideo(){
      const url = this.videoList[this.videoIndex]
      if (url) window.open(url)
    },
    handleVideoDialogBeforeClose(done){
      this.$confirm('本次填写的内容将被清空且不会保存。确定要关闭吗？', '提示', { type: 'warning' })
        .then(() => {
          // 重置视频相关状态
          this.videoList = []
          this.videoIndex = 0
          done()
        })
        .catch(() => {})
    },
    previewImage(index) {
      this.currentImageIndex = index
      // 不再关闭缩略图弹窗
      this.$nextTick(()=>{
        this.imgViewerVisible = true
      })
    },
    onClose(){
      this.imgViewerVisible = false
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
  }
}
</script>
<style lang="stylus" scoped>
.thumbnail-container
  display: flex
  flex-wrap: wrap
  gap: 10px
  justify-content: flex-start
  margin-top: 10px
  max-height: 500px
  overflow-y: auto
  padding-right: 10px

.thumbnail-item
  width: 150px
  height: 150px
  overflow: hidden
  border: 1px solid #eaeaea
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center

  &:hover
    border-color: #409EFF
    box-shadow: 0 0 8px rgba(0,0,0,0.1)

.thumbnail-img
  max-width: 100%
  max-height: 100%
  object-fit: contain

.video-container
  display: flex
  flex-direction: column
  gap: 15px
  margin-top: 10px

.video-item
  width: 100%
  border: 1px solid #eaeaea
  padding: 10px
  border-radius: 4px

.video-player
  width: 100%
  max-height: 400px

.dialog-header
  position: absolute
  top: 10px
  right: 20px
  z-index: 10

.close-icon
  font-size: 20px
  cursor: pointer
  color: #606266

  &:hover
    color: #409EFF


.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Custom/AccessListDialog.vue